/**
 * Mapeamento de fontes de relatório e seus formatos correspondentes
 * 0 = Americano (".")
 * 1 = Brasileiro (",")
 */
const SOURCE_FORMAT_MAP = {
	1: 1, // Believe - Brasileiro
	2: 0, // TheOrchard - Americano
	3: 1, // OneRPM - Brasileiro
	4: 0, // Ingrooves - Americano
	5: 1, // Altafonte - Brasileiro
	6: 0, // FUGA - Americano
	7: 0, // Ingrooves USA - Americano
	8: 0, // Universal Music - Americano (novo layout DS, decimais com ".")
	9: 1, // SomLivre - Brasileiro
	10: 1, // Symphonic - Brasileiro
	11: 1, // CmdShift - Brasileiro
	12: 1, // Universal2 - Brasileiro (legado, fora do seletor)
	13: 1, // Believe2 - Brasileiro
	14: 1, // Virgin - Brasileiro
	15: 0, // Vydia - Americano (valores em USD com ".")
};

/**
 * Mapeamento de fontes de relatório do Backoffice (Autoral) e seus formatos correspondentes
 * 0 = Americano (".")
 * 1 = Brasileiro (",")
 */
const BACKOFFICE_SOURCE_FORMAT_MAP = {
	1: 1, // Youtube - Brasileiro (assumido, pode ser ajustado)
	2: 1, // Backoffice - Brasileiro
	3: 1, // Deezer BMAT - Brasileiro (assumido, pode ser ajustado)
};

export const getFormatBySource = (sourceId) => {
	const id = parseInt(sourceId);
	return SOURCE_FORMAT_MAP[id] !== undefined ? SOURCE_FORMAT_MAP[id] : "";
};

export const getFormatByBackofficeSource = (sourceId) => {
	const id = parseInt(sourceId);
	return BACKOFFICE_SOURCE_FORMAT_MAP[id] !== undefined ? BACKOFFICE_SOURCE_FORMAT_MAP[id] : "";
};

export const getFormatName = (formatId) => {
	const id = parseInt(formatId);
	return id === 0 ? 'Americano (".")' : id === 1 ? 'Brasileiro (",")' : "";
};
